import axios from "axios"
import constant from "./constant";
export const useaxios = async (location, datas) => {
    try {
        var axiosresult = await (await axios.post(constant.host + location, datas));
        
        if (axiosresult.status == 200) {
            return axiosresult.data;
        } else {
            return 'auth_failed';
        }

    } catch (error) {
        
        // if (error.response) {
        //     // The request was made and the server responded with a status code
        //     // that falls out of the range of 2xx (e.g. 400, 401, 404, 500)
        //     console.log("Data:", error.response.data);
        //     console.log("Status:", error.response.status);
        //     console.log("Headers:", error.response.headers);
        // } else if (error.request) {
        //     // The request was made but NO response was received
        //     // This is usually the cause of "Network Error"
        //     console.log("Request made but no response:", error.request);
        // } else {
        //     // Something happened in setting up the request that triggered an Error
        //     console.log("Error Message:", error.message);
        // }
        
        // This prints the full object structure
        console.log("Full Error Config:", error.toJSON());

        return 'auth_failed';
    }
}